import {createReducer} from "redux-act";
import {
	requestUserAchievements,
	requestUserAchievementsFailed,
	requestUserAchievementsSuccess,
} from "modules/actions";
import {RequestState} from "modules/enums";
import {IAchievement} from "modules/reducers";

export interface IAchievementsReducer {
	requestState: RequestState;
	achievements: IAchievement[];
}

const initialState: IAchievementsReducer = {
	requestState: RequestState.IDLE,
	achievements: [],
};

const onRequestUserAchievements = (state: IAchievementsReducer) => ({
	...state,
	requestState: RequestState.Requested,
});

const onRequestUserAchievementsSuccess = (
	state: IAchievementsReducer,
	payload: IAchievement[]
) => ({
	...state,
	requestState: RequestState.Received,
	achievements: payload,
});

const onRequestUserAchievementsFailed = (state: IAchievementsReducer) => ({
	...state,
	requestState: RequestState.Received,
});

export const userAchievements = createReducer<IAchievementsReducer>({}, initialState)
	.on(requestUserAchievements, onRequestUserAchievements)
	.on(requestUserAchievementsSuccess, onRequestUserAchievementsSuccess)
	.on(requestUserAchievementsFailed, onRequestUserAchievementsFailed);
